import {TYPES} from './notification.types';

export class NotificationComponent {

    private element: HTMLDivElement;

    private getNotificationClass(type: string) {
        switch (type) {
            case TYPES.DANGER:
                return 'danger';
            case TYPES.WARNING:
                return 'warning';
             case TYPES.PRIMARY:
                return 'primary';
            default:
                return 'success';
        }
    }

    private getTemplate(type, customContent: string) {
        return `
        <div class="alert alert-dismissible fade in alert-${this.getNotificationClass(type)}">
            <button type="button" class="close notification-close-btn" data-dismiss="alert" aria-label="Close">
               <span aria-hidden="true">×</span>
            </button>
            <span class="notification-icon"></span>
            <span id="error-notification" class="error-notification">${customContent}</span>
        </div>
        `;
    }

    constructor(type: string, content: string) {
        this.element = document.createElement('div');
        this.element.className = `notification-container`;
        this.element.innerHTML = this.getTemplate(type, content);
        this.element.querySelector('button.close').addEventListener('click', () => this.destroy());
    }

    public getElement() {
        return this.element;
    }

    public destroy() {
        const alertEl: HTMLElement = this.element.querySelector('div.alert') as HTMLElement;
        if (alertEl) {
            alertEl.style.opacity = '0';
        }
        setTimeout(() => {
            this.element.remove();
        }, 400);
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/providers/notification/notification.component.ts